import { render, staticRenderFns } from "./ChatDetails.vue?vue&type=template&id=26dca8f2&"
import script from "./ChatDetails.vue?vue&type=script&lang=js&"
export * from "./ChatDetails.vue?vue&type=script&lang=js&"
import style0 from "./ChatDetails.vue?vue&type=style&index=0&id=26dca8f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports